import { type RefObject } from "react";

import { threadOf } from "./thread";
import type { CogentLive } from "./chat-view";

import s from "../cogent.module.css";
import { ChatMessage } from "./chat-message";

export function ChatLog({
  name,
  live,
  log,
}: {
  name: string;
  live: CogentLive;
  log: RefObject<HTMLDivElement | null>;
}) {
  const thread = threadOf(
    live.messages.filter((message) => message.from !== "event").slice(-8),
  );

  if (!thread.length && !live.draft) return null;

  return (
    <div
      ref={log}
      className={s.log}
      role="log"
      aria-label={`Talking with ${name}`}
      aria-live="polite"
      data-testid="cogent-log"
    >
      {thread.map((item) => {
        if (item.kind === "time")
          return (
            <p key={item.key} className={s.when}>
              {item.label}
            </p>
          );

        if (item.kind === "message")
          return <ChatMessage key={item.key} item={item} live={live} />;

        return null;
      })}
      {live.draft ? (
        <div
          className={s.msg}
          data-from="cogent"
          data-first=""
          aria-label={`${name} is writing`}
          data-testid="cogent-typing"
        >
          <span className={s.typing} aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </div>
      ) : null}
    </div>
  );
}
